import * as XLSX from 'xlsx';

// Función para generar la plantilla de envío masivo
export const generarPlantillaMasiva = () => {
  // Definir las columnas/headers de la plantilla
  const headers = [
    'codigoPostal',
    'IdTipoEntrega',
    'IdServicio',
    'valorDeclarado',
    'peso',
    'alto',
    'largo',
    'ancho',
    'fecha',
    'AplicaContrapago',
    'seguro99',
    'diceContener',
    'tipoDocumento',
    'numeroDocumento',
    'nombre',
    'primerApellido',
    'segundoApellido',
    'telefono',
    'direccion',
    'idLocalidad',
    'correo',
    'Observaciones'
  ];

  // Datos de ejemplo
  const datosEjemplo = [
    [
      '110010',        // codigoPostal
      '1',             // IdTipoEntrega (1: Normal, 2: Especial)
      '2',             // IdServicio (1: Estándar, 2: Express, 3: Same Day)
      '50000',         // valorDeclarado
      '1',             // peso (en kg)
      '10',            // alto (en cm)
      '10',            // largo (en cm)
      '10',            // ancho (en cm)
      '03-04-2025',    // fecha (dd-mm-yyyy)
      'true',          // AplicaContrapago (true/false)
      'true',          // seguro99 (true/false)
      'Kit facial delicado',  // diceContener
      'CC',            // tipoDocumento (CC, CE, TI, PP, NIT)
      '12345678',      // numeroDocumento
      'José',          // nombre
      'Vargas',        // primerApellido
      'López',         // segundoApellido
      '3138745728',    // telefono
      'Puerto Espejo Chilacoa Torre 21 Apto 404',  // direccion
      '11001000',      // idLocalidad (código DANE)
      'jose.vargas@email.com',  // correo
      'Kit facial delicado - Manejar con cuidado'  // Observaciones
    ],
    [
      '05001000',      // codigoPostal
      '1',             // IdTipoEntrega
      '2',             // IdServicio
      '75000',         // valorDeclarado
      '2',             // peso
      '15',            // alto
      '15',            // largo
      '15',            // ancho
      '04-04-2025',    // fecha
      'false',         // AplicaContrapago
      'false',         // seguro99
      'Productos cosméticos',  // diceContener
      'CC',            // tipoDocumento
      '87654321',      // numeroDocumento
      'María',         // nombre
      'González',      // primerApellido
      'Rodríguez',     // segundoApellido
      '3209876543',    // telefono
      'Carrera 50 # 25-30 Casa 15',  // direccion
      '05001000',      // idLocalidad
      'maria.gonzalez@email.com',  // correo
      'Productos cosméticos - Frágil'  // Observaciones
    ],
    [
      '76001000',      // codigoPostal - Cali
      '1',             // IdTipoEntrega
      '1',             // IdServicio
      '120000',        // valorDeclarado
      '3',             // peso
      '20',            // alto
      '25',            // largo
      '20',            // ancho
      '05-04-2025',    // fecha
      'true',          // AplicaContrapago
      'true',          // seguro99
      'Electrodomésticos pequeños',  // diceContener
      'CC',            // tipoDocumento
      '11223344',      // numeroDocumento
      'Carlos',        // nombre
      'Martínez',      // primerApellido
      'Sánchez',       // segundoApellido
      '3157894561',    // telefono
      'Avenida 6 Norte # 23-45 Barrio San Antonio',  // direccion
      '76001000',      // idLocalidad
      'carlos.martinez@email.com',  // correo
      'Electrodomésticos - Incluye garantía'  // Observaciones
    ]
  ];

  // Crear un nuevo libro de trabajo
  const workbook = XLSX.utils.book_new();
  
  // Crear la hoja de datos con headers y ejemplos
  const worksheetData = [headers, ...datosEjemplo];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Ajustar el ancho de las columnas
  const colWidths = headers.map(() => ({ wch: 20 }));
  worksheet['!cols'] = colWidths;

  // Agregar la hoja al libro
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Envios');

  // Crear hoja de instrucciones
  const instrucciones = [
    ['INSTRUCCIONES PARA EL ARCHIVO DE ENVÍO MASIVO'],
    [''],
    ['Columna', 'Descripción', 'Valores Permitidos', 'Ejemplo'],
    ['codigoPostal', 'Código postal del destino', 'Código postal válido', '110010'],
    ['IdTipoEntrega', 'Tipo de entrega', '1: Normal, 2: Especial', '1'],
    ['IdServicio', 'Tipo de servicio', '1: Estándar, 2: Express, 3: Same Day', '2'],
    ['valorDeclarado', 'Valor declarado del paquete', 'Número entero', '50000'],
    ['peso', 'Peso en kilogramos', 'Número decimal', '1.5'],
    ['alto', 'Alto en centímetros', 'Número decimal', '10'],
    ['largo', 'Largo en centímetros', 'Número decimal', '15'],
    ['ancho', 'Ancho en centímetros', 'Número decimal', '10'],
    ['fecha', 'Fecha de envío', 'dd-mm-yyyy', '03-04-2025'],
    ['AplicaContrapago', 'Aplica contrapago', 'true / false', 'true'],
    ['seguro99', 'Aplica seguro 99', 'true / false', 'false'],
    ['diceContener', 'Descripción del contenido', 'Texto libre', 'Kit facial delicado'],
    ['tipoDocumento', 'Tipo de documento del destinatario', 'CC, CE, TI, PP, NIT', 'CC'],
    ['numeroDocumento', 'Número de documento', 'Texto/Número', '12345678'],
    ['nombre', 'Nombre del destinatario', 'Texto', 'José'],
    ['primerApellido', 'Primer apellido', 'Texto', 'Vargas'],
    ['segundoApellido', 'Segundo apellido', 'Texto', 'López'],
    ['telefono', 'Teléfono del destinatario', 'Número de 10 dígitos', '3138745728'],
    ['direccion', 'Dirección completa', 'Texto libre', 'Carrera 10 # 20-30'],
    ['idLocalidad', 'Código DANE de la localidad', 'Código DANE válido', '11001000'],
    ['correo', 'Correo electrónico', 'Email válido', 'ejemplo@email.com'],
    ['Observaciones', 'Observaciones adicionales', 'Texto libre', 'Manejar con cuidado'],
    [''],
    ['NOTAS IMPORTANTES:'],
    ['- Todos los campos son obligatorios excepto segundoApellido y Observaciones'],
    ['- Los valores booleanos deben escribirse como "true" o "false"'],
    ['- Las fechas deben estar en formato dd-mm-yyyy'],
    ['- El código postal debe corresponder al destino real'],
    ['- El idLocalidad debe ser un código DANE válido'],
    ['- No elimine los headers (primera fila)'],
    ['- Puede agregar tantas filas como envíos necesite']
  ];

  const instructionsWorksheet = XLSX.utils.aoa_to_sheet(instrucciones);
  
  // Ajustar ancho de columnas para instrucciones
  instructionsWorksheet['!cols'] = [
    { wch: 20 }, // Columna
    { wch: 40 }, // Descripción
    { wch: 30 }, // Valores Permitidos
    { wch: 25 }  // Ejemplo
  ];

  XLSX.utils.book_append_sheet(workbook, instructionsWorksheet, 'Instrucciones');

  return workbook;
};

// Función para descargar la plantilla
export const descargarPlantilla = () => {
  const workbook = generarPlantillaMasiva();
  XLSX.writeFile(workbook, 'plantilla_envio_masivo.xlsx');
};
